export default class Formatter {
    private formatNumberRegex = /\B(?=(\d{3})+(?!\d))/g;

    currency(amount: number): string {
        return `€ ${this.formatNumber(amount)},-`;
    }

    formatNumber(number: number, formatter = '.'): string {
        return number.toString()
            .replace(this.formatNumberRegex, formatter);
    }
}
